<template>
  <div class="search-item-wrapper">
    <div class="search-cancel">
      <input type="text" placeholder="搜索" class="input">
      <mt-button type="primary" size="small">取消</mt-button>
    </div>
    <div class="item-wrapper" 
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    >
      <div class="item" v-for="(item, index) in data" :key="index">
        <h4>课程标题</h4>
        <div class="hname-doctor">
          <p class="hospital-name">四川大学华西医院</p>
          <p class="doctor">肖军</p>
        </div>
        <div class="hname-doctor">
          <p class="hospital-name">2019-01-24 14:34</p>
          <p class="doctor">每周</p>
        </div>
        <div class="introduction">
        课程介绍
        </div>
        <div class="waite-btn-wrapper">
          <mt-button type="primary" size="small" class="waite-btn">停止</mt-button>
          <mt-button type="primary" size="small" class="waite-btn">编辑</mt-button>
          <mt-button type="primary" size="small" class="waite-btn">主持</mt-button>
          <mt-button type="primary" size="small" class="waite-btn">进入</mt-button>
        </div>
      </div>
      <div style="text-align:center;margin-top:0%;" v-if="isLoading">
        <mt-spinner color="#26a2ff" type="double-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    // console.log(333, this.data)
  },
  props: {
    eaducationInfo: {
      type: Array
    }
  },
  data() {
    return {
      allLoaded: false,
      data: this.eaducationInfo,
      isLoading: false,
    }
  },
  methods: {
    // loadTop() {
    //   this.$refs.loadmore.onTopLoaded();
    // },
    // loadBottom() {
    //   this.$refs.loadmore.onBottomLoaded();
    // },

    loadMore() {
      // this.loading = true;
      // this.isLoading = true
      // setTimeout(() => {
      //   let last = this.eaducationInfo[this.eaducationInfo.length - 1];
      //   for (let i = 1; i <= 3; i++) {
      //     this.eaducationInfo.push(last + i);
      //   }
      //   this.isLoading = false
      //   this.loading = false;
      // }, 6000);
    },
  }
}
</script>

<style lang="less">
.search-item-wrapper {
  height:99%;
  // border:  1px solid red;
  .item-wrapper {
    height: 89%;
    overflow: auto;
    // border: 1px solid rebeccapurple;
    .item {
      width: 92%;
      padding-left: 4%;
      padding-right: 4%;
      background: white;
      padding-top: 4%;
      padding-bottom: 1%;
      margin-bottom: 15px;
      h4 {
        margin: 0;
        margin-bottom: 12px;
      }
      .hname-doctor {
        overflow: hidden;
        font-size: 14px;
        margin-bottom: 10px;
        color: #aeaeae;
        .hospital-name {
          float: left;
          margin: 0;
        }
        .doctor {
          float: right;
          margin: 0;
        }
      }
      .introduction {
        font-size: 13px;
        margin-bottom: 14px;
        color: #aeaeae;
        line-height: 20px;
      }
      .waite-btn-wrapper {
        overflow: hidden;
        .waite-btn {
          height: 24px;
          margin-left: 2%;
          float: right;
          margin-bottom: 10px;
        }
      }
      
    }
  }
}

</style>
